module.exports = __webpack_public_path__ + "media/images/countdown__background-492234ee19c5add87561cf0bc5c5f862.jpg";